import { createStyles } from '@material-ui/styles';

const styles = (): any =>
    createStyles({
        root: {},
        icon: {
            height: '2.5rem',
            width: '2.5rem',
            top: 'calc(50% - 1.2rem)',
        },
    });

export default styles;
